import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon, ...props }) => {
  if (!icon) return null;
  return React.createElement(icon, props);
};

export default SafeIcon;